import { isAxiosQueryKey } from './types/AxiosQueryKey';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { QueryKey } from '@tanstack/react-query';
import { ConfigService } from 'app/config/config.service';

export async function axiosQueryFn<T>({ queryKey }: { queryKey: QueryKey }) {
    if (!isAxiosQueryKey(queryKey)) {
        throw new Error('Axios query function called with invalid args');
    }
    const [endpoint, params] = queryKey;

    const instance = createAxiosInstance();

    if (typeof ConfigService.simulateResponseDelayMilliseconds === 'number') {
        await new Promise((resolve) =>
            setTimeout(resolve, ConfigService.simulateResponseDelayMilliseconds),
        );
    }

    const { data } = await instance.get<T>(endpoint, {
        params,
    });

    return data;
}
